import React from 'react';
import PropTypes from 'prop-types';

const Section = (props) => {
  let classes = 'section';
  if (props.className) {
    classes = classes.concat(` ${props.className}`);
  }

  return (
    <section className={classes}>
      { props.children }
    </section>
  );
};

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Section;
